export default __webpack_public_path__ + "static/media/producto-07.5c2fd342.jpg";